import React from 'react';
import { Box, BarChart3, Package } from "lucide-react";
import { FaChartBar, FaBoxOpen, FaTruck, FaBalanceScale, FaCogs, FaUsers, FaClipboardList, FaCalendarAlt, FaChartLine, FaTasks, FaUserTie } from "react-icons/fa";
import { MdInventory } from "react-icons/md";
import { GiRolledCloth } from "react-icons/gi";

export const baseMenuData = [
  {
    name: "OVERALL DASHBOARD",
    icon: <Package size={18} />,
    submenu: [
      { name: "Oberall DashBoard", icon: <FaChartBar size={16} />, path: "/OberallDashBoard" },
    ],
  },
  {
    name: "GREY",
    icon: <Package size={18} />,
    submenu: [
      { name: "Dashboard", icon: <FaChartBar size={16} />, path: "/Dashboard" },
      { name: "Opening", icon: <FaBoxOpen size={16} />, path: "/Opening" },
      { name: "Delivery", icon: <FaTruck size={16} />, path: "/Delivery" },
      {
        name: "Balance",
        icon: <FaBalanceScale size={16} />,
        path: "/Balance",
      },
      { name: "Inward", icon: <MdInventory size={16} />, path: "/Inward" },
      {
        name: "Production group InOut",
        icon: <FaCogs size={16} />,
        path: "/ProductiongroupInOut",
      },
      {
        name: "PartyWise InOut",
        icon: <FaUsers size={16} />,
        path: "/PartyWiseInOut",
      },
      {
        name: "QualityWise InOut",
        icon: <FaClipboardList size={16} />,
        path: "/QualityWiseInOut",
      },
      {
        name: "MonthWise InOut",
        icon: <FaCalendarAlt size={16} />,
        path: "/MonthWiseInOut",
      },
      {
        name: "Total Balance Meter",
        icon: <FaChartLine size={16} />,
        path: "/TotalBalanceMeter",
      },
      { name: "Daywise", icon: <FaTasks size={16} />, path: "/Daywise" },
      {
        name: "GreyInwardReport",
        icon: <GiRolledCloth size={16} />,
        path: "/GreyInwardReport",
      },
      {
        name: "PartyProfile",
        icon: <FaUserTie size={16} />,
        path: "/PartyProfile",
      },
      // {
      //   name: "DemoTable",
      //   icon: <FaUserTie size={16} />,
      //   path: "/Demo",
      // },
    ],
  },
  {
    name: "FAS",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "FINANCIAL STATEMENT",
        icon: <Box size={16} />,
        submenu: [
          { name: "Ledger", path: "/Ledger" },
          { name: "Trial Balance", path: "/TrialBalance" },
          { name: "Profit And Loss", path: "/ProfitAndLoss" },
          { name: "Balance Sheet", path: "/BalanceSheet" },
          { name: "Fund Flow", path: "/FundAndFlow" },
        ],
      },
      {
        name: "OUTSTANDING REPORT",
        icon: <Box size={16} />,
        submenu: [
          { name: "Receivable", path: "/Receivable" },
          { name: "Payable", path: "/Payable" },
        ],
      },
      {
        name: "PROFILE ANAYLYSIS",
        icon: <Box size={16} />,
        submenu: [
          { name: "Customer", path: "/Customer" },
          { name: "Supplier", path: "/Supplier" },
        ],
      },
      {
        name: "DAYBOOK ANALYSIS",
        icon: <Box size={16} />,
        submenu: [
          { name: "Bank", path: "/Bank" },
          {
            name: "Sales",
            submenu: [
              { name: "Dashboard", path: "/SaleDashboard" },
              {
                name: "MonthwisePartyWiseSale",
                path: "/MonthWisePartyWiseSale",
              },
              {
                name: "PartyWiseItemWiseSale",
                path: "/PartyWiseItemWiseSale",
              },
              { name: "ProductionGroupWise", path: "/ProductionGroupWise" },
              { name: "ItemWiseMonthWise", path: "/ItemWiseMonthWise" },
              { name: "ItemWiseSummary", path: "/ItemWiseSummary" },
              { name: "PartyItemWiseSummary", path: "/PartyItemWiseSummary" },
              { name: "MonthItemParty", path: "/MonthItemParty" },
              { name: "PartyWiseQuarter", path: "/PartyWiseQuarter" },
            ],
          },
          {
            name: "Purchase",
            submenu: [
              { name: "Dashboard", path: "/PurchaseDashboard" },
              {
                name: "MonthwisePartywisePurchase",
                path: "/MonthwisePartywisePurchase",
              },
              {
                name: "PartyWiseItemWisePurchase",
                path: "/PartyWiseItemWisePurchase",
              },
              { name: "MonthwiseBookWise", path: "/MonthwiseBookWise" },
              { name: "BookWise", path: "/BookWise" },
              { name: "BookWiseSubBookWise", path: "/BookWiseSubBookWise" },
              {
                name: "BookWiseMonthlyAnalysis",
                path: "/BookWiseMonthlyAnylysis",
              },
            ],
          },
        ],
      },
      {
        name: "STATUTORY REPORT",
        icon: <Box size={16} />,
        submenu: [
          { name: "Gstr", path: "/Gstr" },
          { name: "Tds", path: "/Tds" },
        ],
      },
    ],
  },
  {
    name: "PAYROLL",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "Salry Analysis Dashboard",
        icon: <BarChart3 size={16} />,
        path: "/SalaryAnalysisDashboard",
      },
      {
        name: "Salary Statement",
        icon: <BarChart3 size={16} />,
        path: "/SalaryStateMent",
      },
      {
        name: "Dep Wise Salary Summary",
        icon: <BarChart3 size={16} />,
        path: "/DepWiseSalarySummary",
      },
      {
        name: "Employee Profile",
        icon: <BarChart3 size={16} />,
        path: "/EmployeeProfile",
      },
      {
        name: "Salary Summary",
        icon: <BarChart3 size={16} />,
        path: "/SalarySummary",
      },
      {
        name: "PT Statement",
        icon: <BarChart3 size={16} />,
        path: "/PTStatement",
      },
      {
        name: "ESI Statement",
        icon: <BarChart3 size={16} />,
        path: "/ESIStatement",
      },
      {
        name: "PF Statement",
        icon: <BarChart3 size={16} />,
        path: "/PFStatement",
      },
      {
        name: "ESI/PF/PT Summary",
        icon: <BarChart3 size={16} />,
        path: "/ESI_PF_PT_Summary",
      },
      {
        name: "DepartmentWise Present",
        icon: <BarChart3 size={16} />,
        path: "/DepartmentWisePresent",
      },
    ],
  },
  {
    name: "COLOUR",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "INWARD",
        icon: <Box size={16} />,
        submenu: [{ name: "Inward Analysis", path: "/InwardAnalysis" }],
      },
      {
        name: "CONSUMPTION",
        icon: <Box size={16} />,
        submenu: [
          {
            name: "M/C Group Costing",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupWiseCosting",
          },
          {
            name: "MasterWise M/C Group Costing",
            icon: <BarChart3 size={16} />,
            path: "/MasterWiseMachineGroupCosting",
          },
          {
            name: "M/C Group With M/C Costing",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupWithMachineCosting",
          },
          {
            name: "M/C Group Costing Summary",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupCostingSummary",
          },
          {
            name: "MasterWise Monthly Consumption",
            icon: <BarChart3 size={16} />,
            path: "/MasterWiseMonthlyConsumption",
          },
          {
            name: "M/C  Group Cost Analysis",
            path: "/MachineGroupCostAnlysis",
          },
          {
            name: "M/C Group Batch Costing",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupBatchCosting",
          },
          {
            name: "MasterWise Consumption",
            icon: <BarChart3 size={16} />,
            path: "/MasterWiseConsumption",
          },
          {
            name: "MasterWise Costing",
            icon: <BarChart3 size={16} />,
            path: "/MasterWiseCosting",
          },
        ],
      },
      {
        name: "ANAYLYSIS",
        icon: <Box size={16} />,
        submenu: [
          { name: "ABC", icon: <BarChart3 size={16} />, path: "/Abc" },
          { name: "FSN", icon: <BarChart3 size={16} />, path: "/Fsn" },
          { name: "Stock", iicon: <BarChart3 size={16} />, path: "/Stock" },
          {
            name: "Monthly Stock",
            icon: <BarChart3 size={16} />,
            path: "/MonthlyStock",
          },
          {
            name: "Item/Supplier Analysis",
            icon: <BarChart3 size={16} />,
            path: "/ItemSupplierAnaylysis",
          },
          {
            name: "Party/Item Analysis",
            icon: <BarChart3 size={16} />,
            path: "/PartyItemAnalysis",
          },
        ],
      },
    ],
  },
  {
    name: "MAINTENANCE",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "INWARD",
        icon: <Box size={16} />,
        submenu: [
          { name: "Inward Analysis", path: "/InwardAnalysism" },
          { name: "Inward itemWise", path: "/InwardItemWise" },
        ],
      },
      {
        name: "CONSUMPTION",
        icon: <Box size={16} />,
        submenu: [
          {
            name: "Issue ItemWise",
            icon: <BarChart3 size={16} />,
            path: "/IssueItemWise",
          },
          {
            name: "ItemWise M/CWise Consumption",
            icon: <BarChart3 size={16} />,
            path: "/ItemWiseMachineWiseConsumption",
          },
          {
            name: "M/C Group Wise Consumption",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupWiseConsumtion",
          },
          {
            name: "M/CWise Consumption",
            icon: <BarChart3 size={16} />,
            path: "/MachineWiseConsumption",
          },
          {
            name: "M/CGroup + MonthWise Cosumption",
            icon: <BarChart3 size={16} />,
            path: "/MachineGroupMonthWiseConsumption",
          },
          {
            name: "ItemWise Daily V/S Monthly",
            path: "/itemWiseDailyAndMonthly",
          },
        ],
      },
      {
        name: "ANAYLYSIS",
        icon: <Box size={16} />,
        submenu: [
          {
            name: "FSN Analysis",
            icon: <BarChart3 size={16} />,
            path: "/FsnAnalysis",
          },
          {
            name: "Stock Analysis",
            iicon: <BarChart3 size={16} />,
            path: "/StockAnalysis",
          },
          {
            name: "ABC Analysis",
            icon: <BarChart3 size={16} />,
            path: "/AbcAnalysis",
          },
          {
            name: "Party V/S Item Analysis",
            icon: <BarChart3 size={16} />,
            path: "/PartyItemAnalysisMain",
          },
          {
            name: "Item V/S Supplier Analysis",
            icon: <BarChart3 size={16} />,
            path: "/ItemSupplierAnaylysisMain",
          },
        ],
      },
    ],
  },
  {
    name: "MILLSTAGE",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "GreyStage Balance",
        icon: <BarChart3 size={16} />,
        path: "/GreyStageBalance",
      },
      {
        name: "StageWise In-Out Balance",
        icon: <BarChart3 size={16} />,
        path: "/StageWiseInOutBalance",
      },
      {
        name: "LootWise Report",
        icon: <BarChart3 size={16} />,
        path: "/LootWiseReport",
      },
      {
        name: "GroupWise & StageWise Balance",
        icon: <BarChart3 size={16} />,
        path: "/GroupWiseStageWiseBalance",
      },
      {
        name: "GroupWise StageDetail Report",
        icon: <BarChart3 size={16} />,
        path: "/GroupWiseStageDetailReport",
      },
      {
        name: "GroupWise PartyWise Detail Report",
        icon: <BarChart3 size={16} />,
        path: "/GroupWisePartyWiseDetailReport",
      },
      {
        name: "MachineWise Batch Detail",
        icon: <BarChart3 size={16} />,
        path: "/MachineWiseBatchDetail",
      },
    ],
  },
  {
    name: "MILLSTAGE ENTRY",
    icon: <Package size={18} />,
    submenu: [
      {
        name: "Process Master",
        icon: <Box size={16} />,
        path: "/ProcessMaster",
      },
      {
        name: "Process Quality",
        icon: <Box size={16} />,
        path: "/ProcessQuality",
      },
      {
        name: "SubProcess",
        icon: <Box size={16} />,
        path: "/SubProcess",
      },
      {
        name: "Shade Master",
        icon: <Box size={16} />,
        path: "/ShadeMaster",
      },
      {
        name: "Quality Master",
        icon: <Box size={16} />,
        path: "/QualityMaster",
      },
      {
        name: "TransProcess Type",
        icon: <Box size={16} />,
        path: "/TransProcessType",
      },
      {
        name: "Recipe Master",
        icon: <Box size={16} />,
        path: "/RecipeMasterList",
      },
      {
        name: "Prod. Cons. Recipe",
        icon: <Box size={16} />,
        path: "/ProdConsRecipeList",
      },
      {
        name: "Treatment",
        icon: <Box size={16} />,
        path: "/TreatmentList",
      },
      {
        name: "LotPositioin",
        icon: <Box size={16} />,
        path: "/LotPositioin",
      },
      {
        name: "LotEntry",
        icon: <Box size={16} />,
        path: "/LotEntry",
      },
    ],
  },
  {
    name: "ORDER APPROVAL",
    icon: <FaClipboardList size={18} />,
    path: "/OrderApproval",
  },
  {
    name: "COLLECTION MAN",
    icon: <FaClipboardList size={18} />,
    path: "/CollectionMan",
  },
  {
    name: "USER RIGHTS",
    icon: <FaUsers size={18} />,
    path: "/UserRight",
  },
];
